module.exports = __webpack_public_path__ + "static/organicrainbow2-26bbe1a2c35259e125102d1f86edbcb3.png";